import styled from 'styled-components';

import {
  breakpoints,
  colors,
  fontFamily,
  functions,
  zIndex,
} from '../../ui/variables';

export const SendHelpEmailFormStyle = styled.form`
  height: 800px;
  max-height: 800px;
  max-width: 580px;
  padding: 20px;
  position: relative;
  width: 100%;

  .support-form-text {
    text-align: left;

    .support-text-title {
      ${fontFamily.sourceSansPro.bold};
    }

    .support-text {
      margin-bottom: 22px;
      margin-top: 13px;
      word-break: keep-all;
    }
  }

  .input-container {
    display: flex;
    flex-direction: column;
    height: 75px;
    justify-content: space-between;
    margin-top: 10px;

    &.attachment-container {
      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        align-items: flex-start;
        flex-direction: row;
        justify-content: space-between;
      }
    }

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
    }

    .select-container {
      width: 100%;
    }

    .label-input {
      position: relative;
      width: 100%;

      &.attachment-icon {
        display: flex;
        justify-content: flex-start;

        @media (min-width: ${breakpoints.wxgaPlus.width}px) {
          flex-direction: column;
        }

        @media (min-width: ${breakpoints.uxga.width}px) {
          flex-direction: row;
        }

        svg {
          height: 20px;
          width: 20px;
          margin-left: 5px;
        }
      }

      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        width: 30%;
      }
    }
  }

  .input-container {
    margin-top: 10px;

    .input-container-content {
      width: 100%;

      &.with-error {
        .add-image-container {
          border: dashed 1px ${colors.softRed};
          margin-bottom: 0;
        }

        .submit-button-container {
          margin-bottom: 40px;
        }
      }

      .add-image-container {
        border: dashed 1px ${colors.softBlue};
        border-radius: 12px;
        margin-bottom: 40px;
        margin-top: 10px;
        padding: 36px 0;
        position: relative;
        width: 100%;

        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          margin-top: 0px;
        }

        .instruction {
          ${fontFamily.sourceSansPro.regular};
          ${zIndex.sky};
          align-items: flex-start;
          background-color: ${colors.veryPaleBlue};
          border-radius: 11px;
          box-shadow: 0px 5px 15px ${functions.rgba(colors.black, 0.25)};
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          height: 85%;
          left: 5px;
          padding: 3% 7%;
          position: absolute;
          top: 15px;
          width: 100%;

          .first-message {
            margin-bottom: 3%;
          }

          .second-message {
            color: ${colors.grayishBlue};
          }
        }

        .add-image {
          .input-file {
            display: flex;
          }

          .icon {
            display: block;
            height: 28px;
            left: 32px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 28px;

            @media (min-width: ${breakpoints.ipadLandscape.width}px) {
              height: 36px;
              left: 52px;
              width: 36px;
            }

            svg {
              fill: ${colors.softBlue};
            }
          }

          .form-instruction {
            ${fontFamily.sourceSansPro.bold};
            color: ${colors.softBlue};
            font-size: 16px;
            line-height: 20px;
            text-align: center;
          }

          .input-file-extension {
            ${fontFamily.sourceSansPro.regular};
            color: ${colors.softBlue};
            font-size: 14px;
            line-height: 20px;
            text-align: center;
          }

          .input-file {
            display: block;
            height: 100%;
            left: 0;
            opacity: 0;
            position: absolute;
            top: 0;
            width: 100%;
          }
        }
      }

      .error-message {
        ${fontFamily.sourceSansPro.regular};
        background: transparent;
        border: none;
        color: ${colors.softRed};
        font-size: 12px;
        line-height: 20px;
        margin-bottom: 4px;
      }
    }
  }

  .submit-button-container {
    bottom: 0;
    position: absolute;
    right: 20px;
    width: 60%;
  }
`;
